<template>
    <div class="nav-bar">
        <div
            class="tab-style locale-font mb-7"
            v-for="(item, index) in menuItem"
            :key="item.title"
            :title="item.title"
            :class="classActive(index)"
            @click="go(item.path, index)">
            {{ item.title }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'NavBar',

    props: {
        menuItem: {
            type: Array,
            default: null
        }
    },

    data () {
        return {
            tabIndex: 0
        }
    },

    methods: {
        go (path, index) {
            if (this.tabIndex !== index) {
                this.tabIndex = index
                const payload = {
                    path: path,
                    index: index
                }
                this.$emit('menu-change', payload)
            }
        },

        classActive (index) {
            if (this.tabIndex === index) {
                return 'active'
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.nav-bar {
    display: flex;
    .tab-style {
        padding-right: 3rem;
        padding-top: 1rem;
        padding-bottom: 0.5rem;
        cursor: pointer;
        color: #a8a8a8;
        font-size: 20px;
        font-weight: 350;
    }

    .active {
        border-bottom: 2px solid #D76436;
        color: #D76436;
    }
}
</style>
